import displayNames from "./display-names.json"

const DISPLAY_NAMES = displayNames as Record<string, string>
/** 對外顯示的品名(2026-10-28 使用者核定):依 SKU 對應,沒有對應就用原本的名稱 */
export const displayNameForSku = (sku?: string | null) => (sku ? DISPLAY_NAMES[sku] : undefined)
